import styled from "styled-components";

// Shared styled components for the Classic checkout layout.
// The layout (two columns, left form / right summary) is intentionally
// preserved from the original design — only the visual treatment is refreshed
// (lighter shadows, softer borders, more breathable spacing, modern radii).

export const PageContainer = styled.div`
  min-height: 100vh;
  background-color: ${(props) =>
    props.$transparent
      ? "transparent"
      : props.$styles?.colors?.pageBackground || "#f8fafc"};
  font-family: ${(props) =>
    props.$styles?.typography?.fontFamily ||
    "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Inter', 'Segoe UI', Helvetica, Arial, sans-serif"};
  color: #0f172a;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 18px 32px 0;
  background: transparent;

  @media (max-width: 768px) {
    padding: 14px 18px 0;
  }
`;

export const CheckoutContainer = styled.div`
  display: flex;
  max-width: ${(props) => props.$styles?.layout?.maxWidth || "1180px"};
  margin: 28px auto 48px;
  padding: 0 24px;
  font-family: inherit;

  @media (max-width: 768px) {
    flex-direction: column;
    margin: 14px auto 28px;
    padding: 0 14px;
  }
`;

const cardSurface = `
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04),
              0 4px 16px rgba(15, 23, 42, 0.05);
`;

export const LeftSection = styled.div`
  flex: 1;
  padding: ${(props) =>
    props.$transparent
      ? "0"
      : props.$styles?.spacing?.padding?.leftSection || "32px 36px"};
  ${(props) => (props.$transparent ? "" : cardSurface)}
  margin-right: ${(props) => (props.$transparent ? "0" : "24px")};
  font-family: inherit;

  @media (max-width: 768px) {
    padding: ${(props) => (props.$transparent ? "0" : "22px 18px")};
    margin-right: 0;
    margin-bottom: ${(props) => (props.$transparent ? "0" : "20px")};
  }
`;

export const RightSection = styled.div`
  width: ${(props) => props.$styles?.layout?.rightSectionWidth || "400px"};
  position: sticky;
  top: 24px;
  align-self: flex-start;
  padding: ${(props) =>
    props.$styles?.spacing?.padding?.container || "28px 28px 24px"};
  ${cardSurface}
  font-family: inherit;

  @media (max-width: 768px) {
    width: 100%;
    position: static;
    padding: ${(props) =>
      props.$styles?.spacing?.padding?.containerMobile || "22px 18px"};
  }
`;

export const Logo = styled.div`
  width: 56px;
  height: 56px;
  border-radius: ${(props) =>
    props.$styles?.borderRadius?.round || "14px"};
  background-color: ${(props) =>
    props.$styles?.colors?.primary || "#0f172a"};
  color: ${(props) => props.$styles?.colors?.textOnPrimary || "#ffffff"};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 24px;
  overflow: hidden;
  font-family: inherit;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #fff;
  }
`;
